const systemInfo = {
  systemName: '采联集团',
  systemFullName: '采联集团业务系统'
}

export default systemInfo